import { get, post, del, patch } from "src/services/api";

const fetchCampaignManager = async ({ accountId, assistantId, paginationParams }) => {
  const endpoint = `/accounts/${accountId}/assistants/${assistantId}/outbound${paginationParams ? `?${paginationParams}` : ""}`;
  return await get({ endpoint });
};

const fetchCampaignTasks = async ({ accountId, campaignId, paginationParams }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}/tasks${paginationParams ? `?${paginationParams}` : ""}`;
  return await get({ endpoint });
};

const fetchAllCampaigns = async (params) => {
  const endpoint = `/accounts/${params.accountId}/campaigns`;
  return await get({ endpoint });
};

const fetchCampaign = async (params) => {
  const endpoint = `/accounts/${params.accountId}/campaigns/${params.campaignId}`;
  return await get({ endpoint });
};

const createCampaign = async ({ accountId, data }) => {
  const endpoint = `/accounts/${accountId}/campaigns`;
  return await post({ endpoint, data });
};

const deleteCampaign = async ({ accountId, campaignId, data }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}`;
  return await del({ endpoint, data });
};

const updateCampaign = async ({ accountId, campaignId, data }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}`;
  return await patch({ endpoint, data });
};

const updateCampaignRef = async ({ accountId, campaignId, data }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}/ref`;
  return await patch({ endpoint, data });
};

const fetchOutboundFilterTypes = async ({ accountId, assistantId }) => {
  const endpoint = `/accounts/${accountId}/assistants/${assistantId}/outbound/filters-types`;
  return await get({ endpoint });
};

export default {
  fetchCampaignManager,
  fetchCampaignTasks,
  fetchAllCampaigns,
  fetchCampaign,
  createCampaign,
  deleteCampaign,
  updateCampaign,
  updateCampaignRef,
  fetchOutboundFilterTypes
};
